<template>
  <div class="photo">
    <img v-bind:src="url" width="70%"/>
  </div>
</template>

<script>
export default {
  name: 'Photo',
  props: {
    url: String
  }
}
</script>

<style scoped>
  .photo {
    padding: 8px;
    margin: 10px;
  }

  .photo img {
    border: 14px solid #555;
    max-width: 800px;
  }
</style>
